import { CommandType } from "../../../../common/services/cqs/CommandType";
import { VKAvverkningsanmalanDTO } from "../../models/avverkningsanmalan-models";
import { AvverkningsanmalanCommandBase } from "./AvverkningsanmalanCommandBase";

export class UpdateAvverkningsanmalanCommand extends AvverkningsanmalanCommandBase {
    readonly avverkningsanmalan: VKAvverkningsanmalanDTO;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "UpdateAvverkningsanmalanCommand";

    constructor(kontraktGuid: string, atgardGuid: string, avverkningsanmalan: VKAvverkningsanmalanDTO) {
        super(kontraktGuid, atgardGuid, UpdateAvverkningsanmalanCommand.$type, CommandType.Replace);
        this.avverkningsanmalan = avverkningsanmalan;
    }
}
